// Auto-generated from network-erc-3643.html. Verbatim redesign import. Do NOT edit.
export const SCRIPT = `
/* hero constellation canvas — matches solutions/learn ix-hero animation. */
(function(){
  var cv=document.getElementById('netErc3643HeroCanvas');
  var reducedH=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(!cv || reducedH) return;
  var ctx=cv.getContext('2d'), W,H,DPR,nodes,hubs,raf2,t=0,running2=false;
  function size(){ DPR=Math.min(window.devicePixelRatio||1,2); var r=cv.getBoundingClientRect(); W=r.width;H=r.height; cv.width=W*DPR;cv.height=H*DPR; ctx.setTransform(DPR,0,0,DPR,0,0); }
  function build(){ var n=Math.round(Math.min(96,Math.max(40,W/18))); nodes=[]; for(var i=0;i<n;i++){ nodes.push({x:Math.random()*W,y:Math.random()*H,vx:(Math.random()-0.5)*0.20,vy:(Math.random()-0.5)*0.20,r:Math.random()*1.8+0.8}); }
    hubs=[]; var hn=Math.max(3,Math.round(W/520));
    for(var h=0;h<hn;h++){ hubs.push({x:(0.12+0.76*Math.random())*W,y:(0.16+0.7*Math.random())*H,vx:(Math.random()-0.5)*0.08,vy:(Math.random()-0.5)*0.08,ph:Math.random()*Math.PI*2}); } }
  var LINK=190;
  function frame(){ t+=0.004; ctx.clearRect(0,0,W,H);
    for(var i=0;i<nodes.length;i++){ var p=nodes[i]; p.x+=p.vx;p.y+=p.vy; if(p.x<0||p.x>W)p.vx*=-1; if(p.y<0||p.y>H)p.vy*=-1; }
    for(var hh=0;hh<hubs.length;hh++){ var hb=hubs[hh]; hb.x+=hb.vx; hb.y+=hb.vy; if(hb.x<0||hb.x>W)hb.vx*=-1; if(hb.y<0||hb.y>H)hb.vy*=-1; }
    for(var a=0;a<nodes.length;a++){ for(var b=a+1;b<nodes.length;b++){ var dx=nodes[a].x-nodes[b].x,dy=nodes[a].y-nodes[b].y,d=Math.sqrt(dx*dx+dy*dy);
      if(d<LINK){ var al=(1-d/LINK)*0.28; ctx.strokeStyle='rgba(232,217,184,'+al.toFixed(3)+')'; ctx.lineWidth=0.7; ctx.beginPath(); ctx.moveTo(nodes[a].x,nodes[a].y); ctx.lineTo(nodes[b].x,nodes[b].y); ctx.stroke();
        var seed=(a*7+b*13)%17; var pp=((t*0.4)+seed/17)%1;
        if(d<LINK*0.85){ var px=nodes[a].x+(nodes[b].x-nodes[a].x)*pp, py=nodes[a].y+(nodes[b].y-nodes[a].y)*pp; var pa=(1-d/LINK)*Math.sin(pp*Math.PI)*0.5;
          ctx.fillStyle='rgba(255,122,51,'+pa.toFixed(3)+')'; ctx.beginPath(); ctx.arc(px,py,1.4,0,Math.PI*2); ctx.fill(); } } } }
    for(var g=0;g<hubs.length;g++){ var H0=hubs[g], pulse0=0.5+0.5*Math.sin(t*2.2+H0.ph);
      for(var m=0;m<nodes.length;m++){ var ddx=H0.x-nodes[m].x,ddy=H0.y-nodes[m].y,dd=Math.sqrt(ddx*ddx+ddy*ddy);
        if(dd<LINK*1.15){ var hal=(1-dd/(LINK*1.15))*0.22; ctx.strokeStyle='rgba(168,139,74,'+hal.toFixed(3)+')'; ctx.lineWidth=0.8; ctx.beginPath(); ctx.moveTo(H0.x,H0.y); ctx.lineTo(nodes[m].x,nodes[m].y); ctx.stroke(); } }
      ctx.fillStyle='rgba(232,217,184,'+(0.55+pulse0*0.22).toFixed(3)+')'; ctx.beginPath(); ctx.arc(H0.x,H0.y,2.4+pulse0*1.0,0,Math.PI*2); ctx.fill(); }
    for(var k=0;k<nodes.length;k++){ var q=nodes[k], pulse=0.5+0.5*Math.sin(t*6+k); ctx.fillStyle='rgba(232,217,184,'+(0.30+pulse*0.26).toFixed(3)+')'; ctx.beginPath(); ctx.arc(q.x,q.y,q.r,0,Math.PI*2); ctx.fill(); }
    if(running2) raf2=requestAnimationFrame(frame);
  }
  function start2(){ if(running2)return; running2=true; raf2=requestAnimationFrame(frame); }
  function stop2(){ running2=false; cancelAnimationFrame(raf2); }
  size(); build(); start2();
  window.addEventListener('resize',function(){ size(); build(); });
  if('IntersectionObserver' in window){ var hio=new IntersectionObserver(function(es){es.forEach(function(e){ e.isIntersecting?start2():stop2(); });},{threshold:0.01}); hio.observe(cv); }
})();
/* ============ SIGNATURE: compliance-gate canvas ============
   A live ERC-3643 token sits at the centre, ringed by its embedded ruleset.
   Transfer attempts approach continuously from outside. Each is checked at the
   ring (the contract boundary): eligible transfers (champagne) pass through and
   merge into the core with a soft pulse; ineligible ones (lava) are rejected at
   the boundary with a flash and fade. This visualises the page's thesis, that
   every transfer is checked at the token contract level. Scroll-aware; pauses
   offscreen; respects reduced motion. */
(function(){
  var cv=document.getElementById('gateCanvas'), host=document.getElementById('gateStage');
  if(!cv||!host) return;
  var ctx=cv.getContext('2d');
  var reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var W,H,DPR,cx,cy,R,coreR,S;
  function resize(){
    DPR=Math.min(window.devicePixelRatio||1,2);
    W=cv.clientWidth;H=cv.clientHeight;
    cv.width=W*DPR;cv.height=H*DPR;ctx.setTransform(DPR,0,0,DPR,0,0);
    cx=W*0.5; cy=H*0.47; S=Math.min(W/620,H/520);
    R=128*S; coreR=44*S;
  }
  window.addEventListener('resize',resize); resize();

  var CHAMP=[168,139,74], CHAMPL=[232,217,184], LAVA=[255,122,51], LAVAH=[255,150,96];
  function rgba(c,a){return 'rgba('+(c[0]|0)+','+(c[1]|0)+','+(c[2]|0)+','+a+')';}
  function lerp(a,b,t){return a+(b-a)*t;}
  function ease(t){return 1-Math.pow(1-t,3);}

  // transfer attempts: spawn outside, travel toward the gate
  var REASONS=['Eligible','Eligible','Eligible','Wrong jurisdiction','Not accredited','Sanctioned'];
  var attempts=[];
  function spawn(){
    var ang=Math.random()*Math.PI*2;
    var ok=Math.random()<0.58;
    var reason= ok ? 'Eligible' : REASONS[3+Math.floor(Math.random()*3)];
    attempts.push({ang:ang, t:0, dur:2600+Math.random()*1600, ok:ok, reason:reason, born:performance.now(), rejFlash:0, seed:Math.random()});
  }
  var corePulse=0, ringRot=0, lastSpawn=0;

  function draw(now){
    ctx.clearRect(0,0,W,H);
    ringRot += 0.0016;

    // spawn cadence
    if(!reduced && now-lastSpawn > 760){ lastSpawn=now; if(attempts.length<7) spawn(); }

    // ---- outer compliance ring (the contract boundary) ----
    ctx.save();
    // soft halo
    var halo=ctx.createRadialGradient(cx,cy,R*0.6,cx,cy,R*1.5);
    halo.addColorStop(0,rgba(CHAMP,0.05)); halo.addColorStop(1,rgba(CHAMP,0));
    ctx.fillStyle=halo; ctx.beginPath(); ctx.arc(cx,cy,R*1.5,0,7); ctx.fill();
    // ring
    ctx.strokeStyle=rgba(CHAMPL,0.55); ctx.lineWidth=1.4*S;
    ctx.beginPath(); ctx.arc(cx,cy,R,0,7); ctx.stroke();
    // rule ticks around the ring (the embedded ruleset)
    var TICKS=36;
    for(var i=0;i<TICKS;i++){
      var a=ringRot + i/TICKS*Math.PI*2;
      var inner=R-7*S, outer=R;
      var major=(i%3===0);
      ctx.strokeStyle=rgba(CHAMP, major?0.7:0.35); ctx.lineWidth=(major?1.4:0.8)*S;
      ctx.beginPath();
      ctx.moveTo(cx+Math.cos(a)*inner, cy+Math.sin(a)*inner);
      ctx.lineTo(cx+Math.cos(a)*outer, cy+Math.sin(a)*outer);
      ctx.stroke();
    }
    ctx.restore();

    // ---- transfer attempts ----
    for(var k=attempts.length-1;k>=0;k--){
      var p=attempts[k];
      if(!reduced) p.t += 16/p.dur;
      var prog=ease(Math.min(1,p.t));
      var startR=R*2.15, gateR=R;
      var curR=lerp(startR,gateR,Math.min(1,prog/0.72));  // travel to gate by 72% of life
      var ax=cx+Math.cos(p.ang)*curR, ay=cy+Math.sin(p.ang)*curR;

      // trail
      var tx=cx+Math.cos(p.ang)*(curR+22*S), ty=cy+Math.sin(p.ang)*(curR+22*S);
      var col=p.ok?CHAMPL:LAVA;
      var tg=ctx.createLinearGradient(ax,ay,tx,ty);
      tg.addColorStop(0,rgba(col,0.5)); tg.addColorStop(1,rgba(col,0));
      ctx.strokeStyle=tg; ctx.lineWidth=1.2*S; ctx.beginPath(); ctx.moveTo(ax,ay); ctx.lineTo(tx,ty); ctx.stroke();

      if(prog<0.72){
        // approaching
        ctx.fillStyle=rgba(col,0.92);
        ctx.beginPath(); ctx.arc(ax,ay,4.5*S,0,7); ctx.fill();
      } else {
        if(p.ok){
          // passes through -> travels to core, merges
          var inP=ease((prog-0.72)/0.28);
          var ir=lerp(gateR,0,inP);
          var ix=cx+Math.cos(p.ang)*ir, iy=cy+Math.sin(p.ang)*ir;
          ctx.fillStyle=rgba(CHAMPL,0.92*(1-inP*0.3));
          ctx.beginPath(); ctx.arc(ix,iy,4.5*S*(1-inP*0.5),0,7); ctx.fill();
          if(prog>=1){ corePulse=Math.min(1,corePulse+0.7); attempts.splice(k,1); continue; }
        } else {
          // rejected at the gate: flash + bounce out + fade
          if(p.rejFlash===0) p.rejFlash=now;
          var rj=ease(Math.min(1,(prog-0.72)/0.28));
          var br=lerp(gateR,gateR+34*S,rj);
          var bx=cx+Math.cos(p.ang)*br, by=cy+Math.sin(p.ang)*br;
          // reject flash ring at boundary
          ctx.strokeStyle=rgba(LAVAH,0.6*(1-rj)); ctx.lineWidth=2*S;
          ctx.beginPath(); ctx.arc(cx+Math.cos(p.ang)*gateR, cy+Math.sin(p.ang)*gateR, 8*S+rj*12*S,0,7); ctx.stroke();
          ctx.fillStyle=rgba(LAVA,0.9*(1-rj));
          ctx.beginPath(); ctx.arc(bx,by,4.5*S*(1-rj*0.4),0,7); ctx.fill();
          if(prog>=1){ attempts.splice(k,1); continue; }
        }
      }
      if(prog>=1){ attempts.splice(k,1); }
    }

    // ---- central token core ----
    if(!reduced) corePulse*=0.94;
    var pr=coreR*(1+corePulse*0.10);
    // glow
    var cg=ctx.createRadialGradient(cx,cy,0,cx,cy,pr*2.4);
    cg.addColorStop(0,rgba(CHAMPL,0.22+corePulse*0.25)); cg.addColorStop(1,rgba(CHAMPL,0));
    ctx.fillStyle=cg; ctx.beginPath(); ctx.arc(cx,cy,pr*2.4,0,7); ctx.fill();
    // core disc
    var core=ctx.createRadialGradient(cx-pr*0.3,cy-pr*0.3,0,cx,cy,pr);
    core.addColorStop(0,'#FFF3D4'); core.addColorStop(0.5,'#E8D9B8'); core.addColorStop(1,'#A88B4A');
    ctx.fillStyle=core; ctx.beginPath(); ctx.arc(cx,cy,pr,0,7); ctx.fill();
    ctx.strokeStyle=rgba(CHAMPL,0.8); ctx.lineWidth=1*S; ctx.stroke();
    // label
    ctx.fillStyle='rgba(21,16,42,0.92)'; ctx.textAlign='center'; ctx.textBaseline='middle';
    ctx.font='700 '+(11*S)+'px "JetBrains Mono", monospace';
    ctx.fillText('ERC-3643', cx, cy-3*S);
    ctx.fillStyle='rgba(92,72,36,0.85)'; ctx.font='500 '+(7.5*S)+'px "JetBrains Mono", monospace';
    ctx.fillText('TOKEN', cx, cy+10*S);

    if(running) raf=requestAnimationFrame(draw);
  }

  var raf=0, running=false;
  function start(){ if(running) return; running=true; raf=requestAnimationFrame(draw); }
  function stop(){ running=false; cancelAnimationFrame(raf); }
  if(reduced){
    // static: ring + core + a couple of resolved states
    attempts=[{ang:-0.6,t:0.4,dur:1,ok:true,reason:'Eligible',born:0,rejFlash:0,seed:0.2},
              {ang:2.3,t:0.85,dur:1,ok:false,reason:'Sanctioned',born:0,rejFlash:1,seed:0.5}];
    draw(performance.now());
  } else {
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(es){es.forEach(function(e){ e.isIntersecting?start():stop(); });},{threshold:0.05})
        .observe(host);
    } else start();
  }
})();

/* ============ count-ups (hero proof + proof band) ============ */
(function(){
  var reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function animate(el,end,dur){
    if(reduced){ el.textContent=end; return; }
    var start=null;
    function tick(now){
      if(start===null)start=now;
      var p=Math.min(1,(now-start)/dur);
      el.textContent=Math.floor(end*(1-Math.pow(1-p,3)));
      if(p<1)requestAnimationFrame(tick); else el.textContent=end;
    }
    requestAnimationFrame(tick);
  }
  // hero proof — run on load
  ['hpTokenized:32','hpInst:140','hpJur:20'].forEach(function(s){
    var parts=s.split(':'); var el=document.getElementById(parts[0]); if(el) animate(el,+parts[1],1400);
  });
  // proof band — run when scrolled into view
  var row=document.getElementById('proofRow');
  if(row){
    var go=function(){ row.querySelectorAll('.count').forEach(function(el){ animate(el,+el.dataset.count,1600); }); };
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(es){es.forEach(function(e){ if(e.isIntersecting){ go(); io.disconnect(); } });},{threshold:0.4});
      io.observe(row);
    } else go();
  }
})();

/* reveal: handled by CSS (.reveal { animation: rise }), matching the other pages. */

/* ============ Tokenize: animated ERC-3643 compliance flow (sequenced markets) ============ */
(function(){
  var svg=document.getElementById('tflowSvg'); if(!svg) return;
  var stage=svg.closest('.tflow-stage')||svg;
  var reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var P1=document.getElementById('tf-pkt-p1'), P2=document.getElementById('tf-pkt-p2');
  var S1=document.getElementById('tf-pkt-s1'), S2=document.getElementById('tf-pkt-s2');
  var c1=document.getElementById('tf-check-1'), c2=document.getElementById('tf-check-2');
  var gate=document.getElementById('tf-gate');
  var gateT=document.getElementById('tf-gate-t');
  var boxP=document.getElementById('tf-box-primary'), boxS=document.getElementById('tf-box-secondary');
  var LEFT=[227,400], RIGHT=[700,873];   // left track [node,gate], right track [gate,node]
  function ease(t){ return t<0.5?2*t*t:1-Math.pow(-2*t+2,2)/2; }
  function show(el,o){ el.style.opacity=String(o); }
  function move(el,x0,x1,e){ el.setAttribute('cx', x0+(x1-x0)*e); }
  function lit(on){ c1.classList.toggle('lit',on); c2.classList.toggle('lit',on); }
  if(reduced){ c1.classList.add('lit'); c2.classList.add('lit'); return; }

  var running=false, raf=0, t0=0, phase=0;
  var SP=820, CK=650, GP=720, GAP=480; // durations
  function reset(){
    phase=0; t0=performance.now();
    [P1,P2,S1,S2].forEach(function(p){show(p,0);});
    lit(false); pulseGate(false); boxP.classList.remove('active'); boxS.classList.remove('active');
  }
  function pulseGate(on){ /* gate border stays a clean champagne; no lava firing */ }

  function step(now){
    var dt=now-t0, e=ease(Math.min(1,dt/SP));
    switch(phase){
      /* ---- PRIMARY: Issuers -> gate -> Investors ---- */
      case 0: boxP.classList.add('active'); show(P1,1); move(P1,LEFT[0],LEFT[1],e); if(dt>=SP){show(P1,0);phase=1;t0=now;} break;
      case 1: c1.classList.add('lit'); if(dt>CK){phase=2;t0=now;} break;
      case 2: c2.classList.add('lit'); if(dt>CK){phase=3;t0=now;} break;
      case 3: if(dt>240){phase=4;t0=now;pulseGate(true);show(P2,1);} break;
      case 4: move(P2,RIGHT[0],RIGHT[1],e); if(dt>=SP){show(P2,0);pulseGate(false);phase=5;t0=now;} break;
      case 5: lit(false); boxP.classList.remove('active'); if(dt>GAP){phase=6;t0=now;} break;

      /* ---- SECONDARY 1 (tokens): Investor A -> gate -> Investor B ---- */
      case 6: boxS.classList.add('active'); show(S1,1); move(S1,LEFT[0],LEFT[1],e); if(dt>=SP){show(S1,0);phase=7;t0=now;} break;
      case 7: c1.classList.add('lit'); if(dt>CK){phase=8;t0=now;} break;
      case 8: c2.classList.add('lit'); if(dt>CK){phase=9;t0=now;} break;
      case 9: if(dt>240){phase=10;t0=now;pulseGate(true);show(S2,1);} break;
      case 10: move(S2,RIGHT[0],RIGHT[1],e); if(dt>=SP){show(S2,0);phase=11;t0=now;lit(false);pulseGate(false);} break;
      case 11: if(dt>GAP*0.6){phase=12;t0=now;} break;

      /* ---- SECONDARY 2 (money returns): Investor B -> gate -> Investor A ---- */
      case 12: show(S2,1); move(S2,RIGHT[1],RIGHT[0],e); if(dt>=SP){show(S2,0);phase=13;t0=now;} break;
      case 13: c1.classList.add('lit'); if(dt>CK){phase=14;t0=now;} break;
      case 14: c2.classList.add('lit'); if(dt>CK){phase=15;t0=now;} break;
      case 15: if(dt>240){phase=16;t0=now;pulseGate(true);show(S1,1);} break;
      case 16: move(S1,LEFT[1],LEFT[0],e); if(dt>=SP){show(S1,0);pulseGate(false);phase=17;t0=now;} break;
      case 17: lit(false); boxS.classList.remove('active'); if(dt>GAP){reset();} break;
    }
    if(running) raf=requestAnimationFrame(step);
  }
  function start(){ if(running)return; running=true; reset(); raf=requestAnimationFrame(step); }
  function stop(){ running=false; cancelAnimationFrame(raf); }
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){ if(e.isIntersecting) start(); else stop(); });},{threshold:0.2}); io.observe(stage);
  } else { start(); }
})();
`;
